import { render, staticRenderFns } from "./GtsDocumentViewer.vue?vue&type=template&id=3da6bb6e&scoped=true"
import script from "./GtsDocumentViewer.vue?vue&type=script&lang=js"
export * from "./GtsDocumentViewer.vue?vue&type=script&lang=js"
import style0 from "./GtsDocumentViewer.vue?vue&type=style&index=0&id=3da6bb6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da6bb6e",
  null
  
)

export default component.exports